import {
  CalendarCheck,
  Hammer,
  ShieldCheck,
  KeyRound,
  Headphones,
  Sparkles,
} from "lucide-react";

const BENEFITS = [
  { icon: CalendarCheck, title: "Pago puntual cada mes", text: "Cobras tu renta a principio de mes, sin retrasos ni excusas. Esté la vivienda ocupada o no." },
  { icon: Hammer, title: "Reforma a coste cero", text: "Asumimos los gastos de reforma y mejora necesarios para revalorizar tu vivienda." },
  { icon: ShieldCheck, title: "Sin impagos", text: "Nosotros somos tu inquilino. El riesgo de impago desaparece de la ecuación." },
  { icon: Headphones, title: "Equipo técnico 24h", text: "Cualquier desperfecto o incidencia lo gestionamos nosotros, día y noche." },
  { icon: KeyRound, title: "Acceso a tu vivienda", text: "Mantienes el control total de tu propiedad. Puedes acceder cuando lo necesites." },
  { icon: Sparkles, title: "Vivienda mejor cuidada", text: "Mantenimiento preventivo continuo. Te devolvemos un piso mejor del que entregaste." },
];

export default function Benefits() {
  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="nr-section"
    >
      <div className="nr-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <span className="nr-eyebrow">Beneficios</span>
            <h2 className="nr-h2 mt-4">
              Cobras puntual. Sin gestión. Sin riesgo.
            </h2>
          </div>
          <p className="text-[15px] nr-text-soft max-w-md">
            Una propuesta diseñada para propietarios e inmobiliarias que valoran
            la tranquilidad por encima de la promesa de «rentabilidades mágicas».
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#EAEAEA] border border-[#EAEAEA] rounded-2xl overflow-hidden">
          {BENEFITS.map((b) => (
            <div
              key={b.title}
              data-testid={`benefit-${b.title}`}
              className="bg-white p-8 md:p-10 transition-colors hover:bg-[#F7F7F7]"
            >
              <div className="nr-service-icon !mb-5 !w-11 !h-11 !rounded-xl">
                <b.icon size={20} strokeWidth={1.8} />
              </div>
              <h3 className="nr-h3">{b.title}</h3>
              <p className="mt-3 text-[14px] nr-text-soft leading-relaxed">
                {b.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
